import element_library from "./element_library.json";
import recipe_library from "./recipe_library.json";

export const RECIPE: Record<
  string,
  Record<string, string | Record<string, number>>
> = recipe_library;

export interface SceneData {
  layout: string; // id for the layout glb file
  eraOrder: number;
}

export interface Metadata {
  scene?: SceneData;
  short_description: string;
  detail_description: string;
  name: string;
  type: string;
}
export const LIBRARY: Record<string, Metadata> = element_library;
